// Global static configuration — MVP 0.2

export const ROLES = {
    ADMINISTRATOR: "Administrator",
    TECHNICIAN: "Technician",
};

export const ROLE_OPTIONS = [
    { value: "Administrator", label: "Administrador" },
    { value: "Technician", label: "Técnico" },
];

export const ROLE_LABELS = ROLE_OPTIONS.reduce((acc, r) => {
    acc[r.value] = r.label;
    return acc;
}, {});

export const STATUS_OPTIONS = [
    { value: "active", label: "Ativo" },
    { value: "inactive", label: "Inativo" },
];

// Operational status (Módulo 02) — Equipamento parado ou operante
export const OPERATIONAL_STATUS_OPTIONS = [
    { value: "operante", label: "Operante", tone: "success" },
    { value: "parado", label: "Parado", tone: "danger" },
];
export const OPERATIONAL_STATUS_LABELS = OPERATIONAL_STATUS_OPTIONS.reduce(
    (acc, s) => { acc[s.value] = s.label; return acc; }, {},
);

// Equipamento categories (Módulo 02 aligned)
export const ASSET_CATEGORIES = [
    "Motor Elétrico",
    "Motor",
    "Bomba",
    "Compressor",
    "Redutor",
    "Gerador",
    "Transformador",
    "Painel Elétrico",
    "Ventilador",
    "Soprador",
    "Transportador",
    "Ponte Rolante",
    "Unidade Hidráulica",
    "Máquina",
    "Não sei",
    "Outro",
];

// Photo categories (aligned with PRD 0.2)
export const PHOTO_CATEGORIES = [
    "Geral",
    "Placa",
    "Frente",
    "Traseira",
    "Interna",
    "Defeito",
    "Outro",
];

export const SPECIALTY_OPTIONS = [
    "Elétrica", "Mecânica", "Hidráulica", "Eletrônica",
    "Automação", "Refrigeração", "Estrutural",
    "Instrumentação", "Solda", "Outro",
];

export const BUSINESS_SEGMENTS = [
    "Indústria", "Construção Civil", "Mineração", "Alimentos", "Farmacêutico",
    "Automotivo", "Metalurgia", "Petróleo e Gás", "Água e Saneamento",
    "Energia", "Comercial", "Outro",
];

export const UF_OPTIONS = [
    "AC", "AL", "AM", "AP", "BA", "CE", "DF", "ES", "GO", "MA", "MG", "MS", "MT",
    "PA", "PB", "PE", "PI", "PR", "RJ", "RN", "RO", "RR", "RS", "SC", "SE", "SP", "TO",
];

export const OS_PRIORITIES = [
    { value: "baixa", label: "Baixa", color: "text-muted-foreground" },
    { value: "media", label: "Média", color: "text-secondary" },
    { value: "alta", label: "Alta", color: "text-warning" },
    { value: "critica", label: "Crítica", color: "text-danger" },
];
export const OS_PRIORITY_LABELS = OS_PRIORITIES.reduce((acc, p) => {
    acc[p.value] = p.label;
    return acc;
}, {});

export const OS_CATEGORIES = [
    "Preventiva", "Corretiva", "Preditiva", "Instalação",
    "Inspeção", "Outro",
];

export const WO_STATUSES = [
    {
        value: "nova",
        label: "Nova",
        tone: "green",
        badgeClass:
            "border-emerald-500/40 text-emerald-700 bg-emerald-50 " +
            "dark:text-emerald-400 dark:bg-emerald-950/40 dark:border-emerald-400/40",
        dotClass: "bg-emerald-500",
    },
    {
        value: "enviada",
        label: "Aguardando aceite",
        tone: "purple",
        badgeClass:
            "border-purple-500/40 text-purple-700 bg-purple-50 " +
            "dark:text-purple-400 dark:bg-purple-950/40 dark:border-purple-400/40",
        dotClass: "bg-purple-500",
    },
    {
        value: "aceita",
        label: "Aceita",
        tone: "yellow",
        badgeClass:
            "border-yellow-500/40 text-yellow-700 bg-yellow-50 " +
            "dark:text-yellow-400 dark:bg-yellow-950/40 dark:border-yellow-400/40",
        dotClass: "bg-yellow-500",
    },
    {
        value: "em_atendimento",
        label: "Em Atendimento",
        tone: "orange",
        badgeClass:
            "border-orange-500/40 text-orange-700 bg-orange-50 " +
            "dark:text-orange-400 dark:bg-orange-950/40 dark:border-orange-400/40",
        dotClass: "bg-orange-500",
    },
    {
        value: "finalizada",
        label: "Finalizada",
        tone: "blue",
        badgeClass:
            "border-blue-500/40 text-blue-700 bg-blue-50 " +
            "dark:text-blue-400 dark:bg-blue-950/40 dark:border-blue-400/40",
        dotClass: "bg-blue-500",
    },
    {
        value: "cancelada",
        label: "Cancelada",
        tone: "red",
        badgeClass:
            "border-red-500/40 text-red-700 bg-red-50 " +
            "dark:text-red-400 dark:bg-red-950/40 dark:border-red-400/40",
        dotClass: "bg-red-500",
    },
];
export const WO_STATUS_LABELS = WO_STATUSES.reduce((acc, s) => {
    acc[s.value] = s.label;
    return acc;
}, {});
export const WO_STATUS_META = WO_STATUSES.reduce((acc, s) => {
    acc[s.value] = s;
    return acc;
}, {});
export function getWoStatusBadgeClass(status) {
    return WO_STATUS_META[status]?.badgeClass || "text-muted-foreground";
}
export function getWoStatusDotClass(status) {
    return WO_STATUS_META[status]?.dotClass || "bg-muted-foreground";
}

// Sort options available for the OS list page ("Classificar por")
export const WO_SORT_OPTIONS = [
    { value: "created_at:desc", label: "Mais recentes primeiro", sortBy: "created_at", sortOrder: "desc" },
    { value: "created_at:asc", label: "Mais antigas primeiro", sortBy: "created_at", sortOrder: "asc" },
    { value: "status:asc", label: "Status (fluxo natural)", sortBy: "status", sortOrder: "asc" },
    { value: "priority:desc", label: "Prioridade (maior primeiro)", sortBy: "priority", sortOrder: "desc" },
    { value: "number:desc", label: "Número da OS (novo → antigo)", sortBy: "number", sortOrder: "desc" },
];

export const SC_PRIORITIES = OS_PRIORITIES;
export const SC_PRIORITY_LABELS = OS_PRIORITY_LABELS;
export const SC_CATEGORIES = OS_CATEGORIES;

// -- Workshop (Módulo 04) --------------------------------------------------
// Status do fluxo da Oficina — independentes do status da OS.
// A OS permanece em "em_atendimento" durante todo o ciclo da oficina.
export const WORKSHOP_STATUSES = [
    {
        value: "aguardando_recebimento",
        label: "Aguardando Recebimento",
        badgeClass:
            "border-slate-500/40 text-slate-700 bg-slate-50 " +
            "dark:text-slate-300 dark:bg-slate-900/40 dark:border-slate-400/40",
        dotClass: "bg-slate-500",
    },
    {
        value: "recebido",
        label: "Recebido",
        badgeClass:
            "border-yellow-500/40 text-yellow-700 bg-yellow-50 " +
            "dark:text-yellow-400 dark:bg-yellow-950/40 dark:border-yellow-400/40",
        dotClass: "bg-yellow-500",
    },
    {
        value: "em_diagnostico",
        label: "Em Diagnóstico",
        badgeClass:
            "border-orange-500/40 text-orange-700 bg-orange-50 " +
            "dark:text-orange-400 dark:bg-orange-950/40 dark:border-orange-400/40",
        dotClass: "bg-orange-500",
    },
    {
        value: "aguardando_proposta",
        label: "Aguardando Proposta",
        badgeClass:
            "border-indigo-500/40 text-indigo-700 bg-indigo-50 " +
            "dark:text-indigo-400 dark:bg-indigo-950/40 dark:border-indigo-400/40",
        dotClass: "bg-indigo-500",
    },
];
export const WORKSHOP_STATUS_LABELS = WORKSHOP_STATUSES.reduce((acc, s) => {
    acc[s.value] = s.label;
    return acc;
}, {});
export const WORKSHOP_STATUS_META = WORKSHOP_STATUSES.reduce((acc, s) => {
    acc[s.value] = s;
    return acc;
}, {});

export const WORKSHOP_PHOTO_CATEGORIES = [
    { value: "chegada", label: "Chegada" },
    { value: "antes_desmontagem", label: "Antes da desmontagem" },
    { value: "desmontagem", label: "Desmontagem" },
    { value: "componentes_internos", label: "Componentes internos" },
    { value: "pecas_danificadas", label: "Peças danificadas" },
    { value: "limpeza", label: "Limpeza" },
    { value: "montagem", label: "Montagem" },
    { value: "final", label: "Final" },
    { value: "outro", label: "Outro" },
];
export const WORKSHOP_PHOTO_CATEGORY_LABELS = WORKSHOP_PHOTO_CATEGORIES.reduce(
    (acc, c) => { acc[c.value] = c.label; return acc; }, {},
);

export const WORKSHOP_FAILURE_TYPES = [
    "Mecânica", "Elétrica", "Hidráulica", "Eletrônica",
    "Térmica", "Corrosão / Desgaste", "Fadiga", "Contaminação", "Outro",
];

export const WORKSHOP_GENERAL_CONDITIONS = [
    "Excelente", "Boa", "Regular", "Ruim", "Crítica",
];

export const WORKSHOP_REPAIR_RECOMMENDATIONS = [
    "Reparar", "Substituir", "Descartar", "Reparo com ressalvas",
];

export const WORKSHOP_SERVICE_CATALOG = [
    "Desmontagem",
    "Limpeza",
    "Troca de rolamento",
    "Troca de selo mecânico",
    "Alinhamento de eixo",
    "Balanceamento de rotor",
    "Rebobinamento",
    "Pintura",
    "Montagem",
    "Testes",
    "Outro",
];

export const WORKSHOP_CHECKLIST_ITEMS = [
    { key: "equipment_identified", label: "Equipamento identificado" },
    { key: "nameplate_photographed", label: "Placa fotografada" },
    { key: "external_photos_taken", label: "Fotos externas capturadas" },
    { key: "equipment_tagged", label: "Equipamento etiquetado" },
    { key: "accessories_identified", label: "Acessórios identificados" },
    { key: "components_organized", label: "Componentes organizados" },
    { key: "workspace_prepared", label: "Bancada preparada" },
];

export function getWorkshopStatusBadgeClass(status) {
    return WORKSHOP_STATUS_META[status]?.badgeClass || "text-muted-foreground";
}

// -- Commercial Proposals (Módulo 05) --------------------------------------
export const PROPOSAL_STATUSES = [
    {
        value: "rascunho",
        label: "Rascunho",
        badgeClass:
            "border-slate-500/40 text-slate-700 bg-slate-50 " +
            "dark:text-slate-300 dark:bg-slate-900/40 dark:border-slate-400/40",
        dotClass: "bg-slate-500",
    },
    {
        value: "aguardando_aprovacao",
        label: "Aguardando Aprovação",
        badgeClass:
            "border-yellow-500/40 text-yellow-700 bg-yellow-50 " +
            "dark:text-yellow-400 dark:bg-yellow-950/40 dark:border-yellow-400/40",
        dotClass: "bg-yellow-500",
    },
    {
        value: "aprovada",
        label: "Aprovada",
        badgeClass:
            "border-emerald-500/40 text-emerald-700 bg-emerald-50 " +
            "dark:text-emerald-400 dark:bg-emerald-950/40 dark:border-emerald-400/40",
        dotClass: "bg-emerald-500",
    },
    {
        value: "rejeitada",
        label: "Rejeitada",
        badgeClass:
            "border-red-500/40 text-red-700 bg-red-50 " +
            "dark:text-red-400 dark:bg-red-950/40 dark:border-red-400/40",
        dotClass: "bg-red-500",
    },
    {
        value: "cancelada",
        label: "Cancelada",
        badgeClass:
            "border-neutral-500/40 text-neutral-700 bg-neutral-50 " +
            "dark:text-neutral-300 dark:bg-neutral-900/40 dark:border-neutral-400/40",
        dotClass: "bg-neutral-500",
    },
];
export const PROPOSAL_STATUS_LABELS = PROPOSAL_STATUSES.reduce((acc, s) => {
    acc[s.value] = s.label;
    return acc;
}, {});
export const PROPOSAL_STATUS_META = PROPOSAL_STATUSES.reduce((acc, s) => {
    acc[s.value] = s;
    return acc;
}, {});
export function getProposalStatusBadgeClass(status) {
    return PROPOSAL_STATUS_META[status]?.badgeClass || "text-muted-foreground";
}

// Currency helper (pt-BR / BRL) — used across proposals UI
export function formatBRL(value) {
    const v = Number(value || 0);
    return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(v);
}


export const PERMISSIONS = {
    Administrator: { "*": ["create", "read", "update", "delete"] },
    Technician: {
        // Cliente: pode ver (escopo) e CRIAR (fica só dele) e atualizar os seus
        customers: ["read", "create", "update"],
        // Equipamentos: só do escopo. Pode criar (para clientes dele) e atualizar
        assets: ["read", "create", "update"],
        // OS: pode ver (escopo), CRIAR (auto-atribui) e atualizar (aceitar, notas, finalizar)
        work_orders: ["read", "create", "update"],
        // Oficina: só do escopo (WOs dele). Diagnóstico completo
        workshop: ["read", "create", "update"],
        // Dashboard e busca
        dashboard: ["read"],
        search: ["read"],
        // Uploads (fotos, laudos)
        uploads: ["create", "read"],
        // Perfil próprio (o técnico usa /users/me para o seu próprio perfil)
        users: ["read"],
        // Técnicos: leitura para dropdowns (ele mesmo em OS que ele cria)
        technicians: ["read"],
        // SEM ACESSO: commercial_proposals, finance, company, customer_segments,
        // admin (Zona de Perigo), demais itens de configuração
    },
};

export function canPerform(role, resource, action) {
    const perms = PERMISSIONS[role] || {};
    if (perms["*"] && perms["*"].includes(action)) return true;
    return (perms[resource] || []).includes(action);
}
